import { Component, input } from '@angular/core';

@Component({
    selector: 'ea-loader',
    templateUrl: './ea-loader.html',
    styleUrl: './ea-loader.scss',
    host: {
        '[class.compact]': '$compact()',
        '[style.color]': '$color() ?? null',
    },
})
export class EaLoader {
    public readonly $compact = input(false);
    public readonly $color = input<string>();
}
